import './style.css';

import React, { useState } from 'react';
import * as Yup from 'yup';
import { Button, Group, Dialog } from '@economic/taco';

import internalApiClient from '../../../util/api/internalApiClient';
import { Field, Form } from '../../Form';
import { t, useLocalization } from '../../l10n/l10n';
import { Column, Row } from '../../Grid/Grid';

function FooterError({ error }) {
    if (error === null || error === undefined || error === '') {
        return null;
    }
    return (
        <div className="vismaconnect-add-account-dialog error-message">
            <div className="vismaconnect-add-account-dialog error-message-body">{error}</div>
        </div>
    );
}

interface Props {
    onOk?: () => void;
    onCancel?: () => void;
    open: boolean;
    setOpen: (open: boolean) => void;
}

export default function VismaConnectAddAccountDialog({ onOk, onCancel, open, setOpen }: Props) {
    const loadingTexts = useLocalization(textIds);
    const [error, setError] = useState('');

    if (loadingTexts || !open) {
        return null;
    }

    function onHide() {
        onCancel?.();
        setOpen(false);
    }

    const validationSchema = Yup.object().shape({
        agreementNumber: Yup.string().required(),
        userId: Yup.string().required(),
        password: Yup.string().required(),
    });

    function handleSubmit(values: { agreementNumber: any; userId: any; password: any; confirm: any }) {
        if (values.confirm === false) {
            setError(t`FORM_ADD_ACCOUNT_PLEASE_CONFIRM`);
            return;
        }

        const requestModel = {
            agreementNumber: values.agreementNumber,
            userId: values.userId,
            password: values.password,
        };

        internalApiClient
            .post(`/users/AddAccount`, requestModel)
            .then(() => {
                onOk?.();
                setOpen(false);
            })
            .catch(error => {
                setError(error.error || error.response.data);
            });
    }

    return (
        <Dialog open={open} onChange={setOpen} onClose={onHide} closeOnEscape={false} showCloseButton={false}>
            <Dialog.Content aria-label={t('FORM_ADD_ACCOUNT_HEADLINE')}>
                <Form onSubmit={handleSubmit} validationSchema={validationSchema} skipNotifications>
                    <Row>
                        <Column>
                            <div>
                                <h3 style={{ marginTop: 0, fontWeight: 'bold' }}>{t('FORM_ADD_ACCOUNT_HEADLINE')}</h3>
                                <p>{t`FORM_ADD_ACCOUNT_DESCRIPTION`}</p>
                            </div>
                        </Column>
                        <Column>
                            <Field.Text
                                name="agreementNumber"
                                label={t`FORM_ADD_ACCOUNT_EDITFIELD_AGREEMENT`}
                                required
                                type="number"
                            />

                            <Field.Text name="userId" label={t`FORM_ADD_ACCOUNT_EDITFIELD_USERID`} required />

                            <Field.Text name="password" label={t`FORM_ADD_ACCOUNT_EDITFIELD_PASSWORD`} required type="password" />

                            <Field.Checkbox
                                text={t`FORM_ADD_ACCOUNT_EDITFIELD_CONFIRMATION`}
                                name="confirm"
                                initialValue={false}
                            />
                        </Column>
                    </Row>
                    <FooterError error={error} />

                    <Dialog.Footer>
                        <Group>
                            <Dialog.Close>
                                <Button appearance="ghost">{t`SHARED_FORM_CANCEL`}</Button>
                            </Dialog.Close>
                            <Button appearance="primary" type="submit">
                                {t`SHARED_FORM_OK`}
                            </Button>
                        </Group>
                    </Dialog.Footer>
                </Form>
            </Dialog.Content>
        </Dialog>
    );
}

const textIds = [
    'FORM_ADD_ACCOUNT_HEADLINE',
    'FORM_ADD_ACCOUNT_DESCRIPTION',
    'FORM_ADD_ACCOUNT_EDITFIELD_AGREEMENT',
    'FORM_ADD_ACCOUNT_EDITFIELD_USERID',
    'FORM_ADD_ACCOUNT_EDITFIELD_PASSWORD',
    'FORM_ADD_ACCOUNT_EDITFIELD_CONFIRMATION',
    'GENERALINPUT_ERROR_FILLCURRENTFIELD',
    'GENERALINPUT_ERROR_ONLYDIGITS',
    'FORM_ADD_ACCOUNT_PLEASE_CONFIRM',
    'SHARED_FORM_OK',
    'SHARED_FORM_CANCEL',
];
